import React from 'react'

import Section from 'Components/Section'
import GridRow from 'Components/Grid/GridRow'
import Report from 'Components/Report'

const MessageRow = ({ row: message }) => (
  <>
    <GridRow>
      <div>{message.patientRef}</div>
      <div>{message.tCode}</div>
      {Object.keys(message.message).map(item => {
        return <div>{message.message[item]}</div>
      })}
    </GridRow>
  </>
)

const columns = [
  { header: 'Patient', property: 'patientRef' },
  { header: 'T-Code', property: 'tCode' }
]

export default ({ doctor, initials, columnCategories }) => {
  return (
    <>
      <Section header="Provider" title={initials} />
      {Object.keys(doctor).map(journeyId => {
        const tcodeItem = doctor[journeyId]

        return (
          <>
            <Section header="Journey" title={tcodeItem[0].journeyName} />
            <Report
              id="message"
              report={{ messageReport: tcodeItem }}
              columns={[...columns, ...columnCategories]}
              ReportRow={MessageRow}
              defaultSortIndex={0}
              prop="messageReport"
            />
          </>
        )
      })}
    </>
  )
}
